export const FloatBtn = () => {
  return (
    <a className="float-btn" href="https://wa.me/message/Q7YJ27ZCKM5UO1" target="_blank">
      <p>Consulte um especialista</p>
      <i class="fa fa-whatsapp"></i>
    </a>
  );
};
